<template>
  <div>
    <h2 class="content-block">Pegawai List JS</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          class="dx-card wide-card"
          id="dataGrid"
          :data-source="dataSource"
          key-expr="ID"
          :focused-row-index="0"
          :show-borders="true"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :allow-column-reordering="true"
        >
          <dx-paging :page-size="5" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <dx-filter-row :visible="true" />

          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxSelection mode="multiple" />
          <DxColumnFixing :enabled="true" />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem location="after" template="button-template" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <!-- :text="expanded ? 'Collapse All' : 'Expand All'" -->
          <template #button-template>
            <DxButton text="Import data" :width="136" @click="importClick" />
          </template>

          <dx-column
            data-field="NamaPegawai"
            caption="Pegawai"
            :fixed="true"
            fixed-position="left"
            :allow-sorting="true"
          />
          <dx-column data-field="Cabang" caption="Cabang">
            <dx-lookup
              display-expr="nama"
              value-expr="id"
              :data-source="cabangs"
            />
          </dx-column>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="ID"
            caption=" "
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  DxExport,
  DxSelection,
  // DxButton,
  DxToolbar,
  DxItem,
} from "devextreme-vue/data-grid";
import ODataStore from "devextreme/data/odata/store";
// import DataSource from "devextreme/data/data_source";
import notify from "devextreme/ui/notify";
import DxDropDownButton from "devextreme-vue/drop-down-button";
// eslint-disable-next-line
import router from "@/router";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DxButton } from "devextreme-vue/button";

import { pegawais } from "./dataPegawai.js";

// const cabangs = [
//   { name: "Pusat", value: "Pusat" },
//   { name: "Lovina", value: "Lovina" },
//   { name: "Seririt", value: "Seririt" },
//   { name: "Pancasari", value: "Pancasari" },
//   { name: "Gerokgak", value: "Gerokgak" },
//   { name: "Busungbiu", value: "Busungbiu" },
// ];

// const cabangStore = new ODataStore({
//   type: "odata",
//   url: "http://127.0.0.1/odata/Cabangs",
//   key: "id",
//   version: 4,
//   beforeSend: function (e) {
//     console.log(e);
//     e.headers = {
//       "odata-version": "4.0",
//     };
//   },
// });

// const cabangDataSource = new DataSource({
//   store: cabangStore
// });

const options = ["Detail", "Transfer", "Resign", "Delete"];

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxPaging,
    // DxEditing,
    DxColumnFixing,
    // DxButton,
    DxDropDownButton,
    DxExport,
    DxSelection,
    DxToolbar,
    DxItem,
    DxButton,
  },
  data() {
    return {
      events: [],
      dataSource: pegawais,
      // cities: cities,
      // cabangs: cabangDataSource,
      cabangs: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      options: options,
      router: router,
    };
  },
  methods: {
    importClick() {
      this.router.push({
        name: "practice-sheetjs",
        query: { table: "pegawai" },
      });
    },
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    clearEvents() {
      this.events = [];
    },

    onSaving(e) {
      console.log(e);
    },
    myCommand(e) {
      console.log(e);
      alert("command");
    },
    onItemClick(e) {
      console.log(e.element.id);
      let pegawaiId = e.element.id;
      notify(e.itemData.name || e.itemData, "success", 600);
      this.router.push({ name: "tab-treeview", query: { id: pegawaiId } }); //?id=1
      // this.router.push({ name: "tab-treeview", params: { id: pegawaiId } }); //id tak terlihat di url
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
</style>
